var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertionWaitTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.72,
    fill: "#F6A723"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20186_136146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 24.3327C20.6023 24.3327 24.3333 20.6017 24.3333 15.9993C24.3333 11.397 20.6023 7.66602 16 7.66602C11.3976 7.66602 7.66663 11.397 7.66663 15.9993C7.66663 20.6017 11.3976 24.3327 16 24.3327Z",
    stroke: "white",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.666V15.9993L17.6667 17.666",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20186_136146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertionWaitTime);
export default __webpack_public_path__ + "static/media/convertionWaitTime.46f2c9eaf0aab7f780cd22d14642d97f.svg";
export { ForwardRef as ReactComponent };